import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const categories = [
    { id: 0, name: 'الكل', icon: 'ri-apps-line' },
    { id: 1, name: 'خضروات', icon: 'ri-leaf-line' },
    { id: 2, name: 'فواكه', icon: 'ri-apple-line' },
    { id: 3, name: 'ألبان', icon: 'ri-cup-line' },
    { id: 4, name: 'لحوم', icon: 'ri-restaurant-line' },
    { id: 5, name: 'مخبوزات', icon: 'ri-cake-line' }
  ];

  const products = [
    {
      id: 1,
      name: 'طماطم طازجة - كيلو',
      price: '12',
      rating: 4.8,
      reviews: 234,
      image: 'https://public.readdy.ai/ai/img_res/b43a248860b331947028690f35e470ea.jpg'
    },
    {
      id: 2,
      name: 'حليب طازج - لتر',
      price: '15',
      rating: 4.9,
      reviews: 456,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20milk%20bottle%20dairy%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20white%20and%20blue%20packaging%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=grocery2&orientation=squarish'
    },
    {
      id: 3,
      name: 'خبز طازج',
      price: '8',
      rating: 4.7,
      reviews: 189,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20bread%20loaf%20bakery%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20golden%20brown%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=grocery3&orientation=squarish'
    },
    {
      id: 4,
      name: 'تفاح أحمر - كيلو',
      price: '18',
      rating: 5.0,
      reviews: 567,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20red%20apples%20fruit%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20bright%20red%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=grocery4&orientation=squarish'
    }
  ];

  const features = [
    {
      icon: 'ri-truck-line',
      title: 'توصيل سريع',
      desc: 'خلال ساعتين',
      color: 'from-blue-400 to-blue-600'
    },
    {
      icon: 'ri-leaf-line',
      title: 'منتجات طازجة',
      desc: 'يومياً من المزرعة',
      color: 'from-green-400 to-green-600'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'أسعار منافسة',
      desc: 'عروض يومية',
      color: 'from-purple-400 to-purple-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'ضمان الجودة',
      desc: 'منتجات مضمونة',
      color: 'from-orange-400 to-orange-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50" dir="rtl">
      {/* Side Menu Overlay */}
      {isMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity duration-300"
          onClick={() => setIsMenuOpen(false)}
        ></div>
      )}

      {/* Side Menu */}
      <div 
        className={`fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-50 transform transition-transform duration-300 ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="h-full flex flex-col">
          {/* Menu Header */}
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 pb-8">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-bold text-white">القائمة</h2>
              <button 
                onClick={() => setIsMenuOpen(false)}
                className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
              >
                <i className="ri-close-line text-white text-xl"></i>
              </button>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                <i className="ri-user-line text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-lg">مرحباً بك</h3>
                <Link to="/login" className="text-white/90 text-sm hover:text-white transition-colors">
                  تسجيل الدخول
                </Link>
              </div>
            </div>
          </div>

          {/* Menu Items */}
          <div className="flex-1 overflow-y-auto py-4">
            {[
              { icon: 'ri-home-line', label: 'الرئيسية', link: '/' },
              { icon: 'ri-search-line', label: 'استكشف', link: '/explore' },
              { icon: 'ri-shopping-cart-line', label: 'السلة', link: '/cart' },
              { icon: 'ri-heart-line', label: 'المفضلة', link: '/favorites' },
              { icon: 'ri-shopping-bag-line', label: 'طلباتي', link: '/orders' },
              { icon: 'ri-notification-line', label: 'الإشعارات', link: '/notifications' },
              { icon: 'ri-user-line', label: 'حسابي', link: '/profile' },
              { icon: 'ri-settings-line', label: 'الإعدادات', link: '/profile' },
              { icon: 'ri-customer-service-line', label: 'الدعم الفني', link: '/profile' },
              { icon: 'ri-information-line', label: 'عن التطبيق', link: '/profile' }
            ].map((item, index) => (
              <Link
                key={index}
                to={item.link}
                onClick={() => setIsMenuOpen(false)}
                className="flex items-center gap-4 px-6 py-4 hover:bg-gray-50 transition-colors group"
              >
                <div className="w-10 h-10 bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl flex items-center justify-center group-hover:from-blue-100 group-hover:to-purple-100 transition-colors">
                  <i className={`${item.icon} text-blue-600 text-xl`}></i>
                </div>
                <span className="text-gray-800 font-medium">{item.label}</span>
                <i className="ri-arrow-left-s-line text-gray-400 mr-auto"></i>
              </Link>
            ))}
          </div>

          {/* Menu Footer */}
          <div className="p-6 border-t border-gray-100">
            <button className="w-full py-3 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-xl font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2">
              <i className="ri-logout-box-line text-xl"></i>
              تسجيل الخروج
            </button>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-40">
        <div className="px-4 py-3 flex items-center justify-between">
          <button 
            onClick={() => setIsMenuOpen(true)}
            className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-xl transition-colors"
          >
            <i className="ri-menu-line text-2xl text-gray-800"></i>
          </button>
          <h1 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" style={{ fontFamily: '"Pacifico", serif' }}>
            logo
          </h1>
          <Link to="/cart" className="w-10 h-10 flex items-center justify-center relative hover:bg-gray-100 rounded-xl transition-colors">
            <i className="ri-shopping-cart-line text-2xl text-gray-800"></i>
            <span className="absolute top-1 right-1 w-5 h-5 bg-gradient-to-r from-pink-500 to-red-500 rounded-full text-white text-xs flex items-center justify-center font-bold">3</span>
          </Link>
        </div>
      </nav>

      {/* Main Content */}
      <div className="pt-16 pb-20">
        {/* Hero Section */}
        <div className="px-4 pt-6 pb-4">
          <div className="relative h-48 rounded-3xl overflow-hidden shadow-lg">
            <img 
              src="https://readdy.ai/api/search-image?query=Fresh%20grocery%20shopping%20supermarket%20scene%20with%20colorful%20fruits%20and%20vegetables%2C%20shopping%20cart%20filled%20with%20fresh%20produce%2C%20bright%20and%20clean%20supermarket%20interior%2C%20vibrant%20colors%2C%20professional%20commercial%20photography%2C%20high%20quality%2C%20sharp%20focus%2C%20modern%20grocery%20store%20atmosphere&width=800&height=400&seq=grohero1&orientation=landscape"
              alt="Hero"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            <div className="absolute bottom-6 right-6 left-6">
              <h2 className="text-2xl font-bold text-white mb-2">عروض طازجة يومياً</h2>
              <p className="text-white/90 text-sm mb-3">خصم يصل إلى 30% على الخضروات والفواكه</p>
              <button className="px-6 py-2 bg-white text-blue-600 rounded-full font-bold text-sm shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                تسوق الآن
              </button>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="px-4 mb-6">
          <div className="relative">
            <input 
              type="text"
              placeholder="ابحث عن منتجات البقالة..."
              className="w-full px-5 py-3.5 pr-12 rounded-2xl bg-white shadow-md border-none text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all duration-300"
            />
            <button className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl flex items-center justify-center">
              <i className="ri-search-line text-white text-lg"></i>
            </button>
          </div>
        </div>

        {/* Categories */}
        <div className="px-4 mb-6">
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`flex-shrink-0 px-5 py-2.5 rounded-full font-medium text-sm transition-all duration-300 transform hover:scale-105 ${
                  activeCategory === cat.id
                    ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                    : 'bg-white text-gray-700 shadow-md'
                }`}
              >
                <i className={`${cat.icon} ml-1.5`}></i>
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        {/* Features Grid */}
        <div className="px-4 mb-6">
          <div className="grid grid-cols-2 gap-3">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-4 shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${feature.color} flex items-center justify-center mb-3`}>
                  <i className={`${feature.icon} text-white text-xl`}></i>
                </div>
                <h3 className="font-bold text-gray-800 text-sm mb-1">{feature.title}</h3>
                <p className="text-gray-500 text-xs">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Products Section */}
        <div className="px-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-bold text-gray-800">المنتجات المميزة</h3>
            <button className="text-blue-600 text-sm font-medium flex items-center">
              عرض الكل
              <i className="ri-arrow-left-s-line mr-1"></i>
            </button>
          </div>

          <div className="grid grid-cols-2 gap-3" data-product-shop>
            {products.map((product) => (
              <Link
                key={product.id}
                to={`/product/${product.id}`}
                className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                <div className="relative h-40 overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <button className="absolute top-2 left-2 w-8 h-8 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-md">
                    <i className="ri-heart-line text-gray-700 text-sm"></i>
                  </button>
                </div>
                <div className="p-3">
                  <h4 className="font-bold text-gray-800 text-sm mb-1 line-clamp-2">{product.name}</h4>
                  <div className="flex items-center gap-1 mb-2">
                    <i className="ri-star-fill text-yellow-400 text-xs"></i>
                    <span className="text-xs font-medium text-gray-700">{product.rating}</span>
                    <span className="text-xs text-gray-400">({product.reviews})</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">{product.price} ر.س</span>
                    <button className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg flex items-center justify-center shadow-md">
                      <i className="ri-add-line text-white text-lg"></i>
                    </button>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 z-50">
        <div className="grid grid-cols-5 h-16">
          <button className="flex flex-col items-center justify-center gap-1 text-blue-600">
            <i className="ri-home-fill text-xl"></i>
            <span className="text-xs">الرئيسية</span>
          </button>
          <Link to="/explore" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-search-line text-xl"></i>
            <span className="text-xs">استكشف</span>
          </Link>
          <Link to="/cart" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors relative">
            <i className="ri-shopping-cart-line text-xl"></i>
            <span className="text-xs">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-5 h-5 bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
          </Link>
          <Link to="/favorites" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-heart-line text-xl"></i>
            <span className="text-xs">المفضلة</span>
          </Link>
          <Link to="/profile" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-user-line text-xl"></i>
            <span className="text-xs">حسابي</span>
          </Link>
        </div>
      </nav>
    </div>
  );
}
